import MvSelect from "Generic/MvSelect";
import React, { FC, ReactElement, useEffect, useState, useContext } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

//styles
import "./ContractsInfo.sass";
import { MvTextOrEdit } from "Generic/MvTextOrEdit";
import Item from "Interfaces/ItemInterface";
import ToolTip from 'Generic/ToolTip';
import { Position } from 'Generic/ToolTip/ToolTip';
// @ts-ignore
import { LocalizationContext } from 'react-localize';
import { Tip } from "Interfaces/TipInterface";
import { inputErrors } from "../types";

enum PageErrorType {
    'pointsError' = 'pointsError',
    'exceededLimit' = 'exceededLimit', //remove this
    'zeroPoints' = 'zeroPoints',
    'noUsageTypePoints' = 'noUsageTypePoints',
    contractIdInputError = "contractIdInputError",
    usageYearInputError = "usageYearInputError",
    usageTypeInputError = "usageTypeInputError",
    pointsInputError = "pointsInputError",
    twentyThousandError = "twentyThousandError",
    pointLimitError = "pointLimitError"
};

interface PageErrors {
    [PageErrorType.pointsError]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.exceededLimit]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.zeroPoints]: {
        message: string;
        isErrored: boolean;
    },
    [PageErrorType.noUsageTypePoints]: {
        message: string;
        isErrored: boolean;
    }
}

type Props = {
    contract: contract[];
    key: number;
    id: number;
    currentContract: selectedContract;
    uniqueContracts: string[];
    displayRemoveButton: boolean;
    removeContracts(key: number): void;
    addContractWithData(contract: selectedContract, key: number): void;
}

type selectedContract = {
    contractId: string;
    usageYear: number;
    usageType: string;
    numberofPointsToTransfer: number;
    inputErrors: inputErrors
}

type contract = {
    contractNumber: string;
    contractID: number;
    usageYear: number;
    usageType: string;
    pointsAllocated: number;
    pointsRemaining: number;
    contractInfo: string;
    isValidforTransferPoints: boolean
}

type State = {
    selectedContractId: string,
    selectedUsageYear: number,
    selectedUsageType: string,
    numberofPointsToTransfer: number,
    usageYearDisabled: boolean,
    usageTypeDisabled: boolean,
    pointsDisabled: boolean,
    usageYears: string[],
    usageTypes: string[],
    inputErrors: inputErrors
}

const inputErrorsForEntryNew: inputErrors = {
    [PageErrorType.contractIdInputError]: {
        message: 'Please enter details for the previous contract, before attempting to add a new contract',
        isErrored: false
    },
    [PageErrorType.usageYearInputError]: {
        message: 'Please enter details for the previous contract, before attempting to add a new contract',
        isErrored: false,
    },
    [PageErrorType.usageTypeInputError]: {
        message: 'Please enter details for the previous contract, before attempting to add a new contract',
        isErrored: false,
    },
    [PageErrorType.pointsInputError]: {
        message: 'Please enter details for the previous contract, before attempting to add a new contract',
        isErrored: false,
    },
    [PageErrorType.twentyThousandError]: {
        message: 'Please enter less than 20000 points',
        isErrored: false
    },
    [PageErrorType.pointLimitError]: {
        message: 'Please enter less than the points remaining',
        isErrored: false
    },
    [PageErrorType.pointsError]: {
        message: 'Please enter points in increments of 5',
        isErrored: false
    },
    [PageErrorType.zeroPoints]: {
        message: 'sorry, not enough points',
        isErrored: false
    },
    [PageErrorType.noUsageTypePoints]: {
        message: 'There are no available points to transfer',
        isErrored: false
    }
}

const InitState: State = {
    selectedContractId: "",
    selectedUsageYear: 0,
    selectedUsageType: "",
    numberofPointsToTransfer: 0,
    // pageErrors: InitPageErrors,
    usageYearDisabled: true,
    usageTypeDisabled: true,
    pointsDisabled: true,
    usageYears: [],
    usageTypes: [],
    inputErrors: inputErrorsForEntryNew
}

const ContractsInfo: FC<any> = (props: Props): ReactElement => {
    const [contractState, setContractState] = useState(InitState);
    const { localize } = useContext(LocalizationContext);

    /**this use effect was added to avoid bugs with removing a contract or modifying an existing contract */
    useEffect(() => {
        setContractState({
            ...contractState,
            selectedContractId: props.currentContract.contractId,
            selectedUsageYear: props.currentContract.usageYear,
            selectedUsageType: props.currentContract.usageType,
            numberofPointsToTransfer: props.currentContract.numberofPointsToTransfer,
            inputErrors: props.currentContract.inputErrors
        })
    }, [props.currentContract]);

    // useEffect(() => {
    //     setContractState({
    //         ...contractState,

    //     })
    // }, []);

    useEffect(() => {
        // const isEmpty = Object.values(contractState).some(x => x === null || x === '' || x === 0 || x === String(0));

        // if(!contractState.inputErrors[PageErrorType.pointsError].isErrored && !contractState.inputErrors[PageErrorType.noUsageTypePoints].isErrored) {
        //     const contract: selectedContract = {
        //         contractId: contractState.selectedContractId,
        //         usageYear: contractState.selectedUsageYear,
        //         usageType: contractState.selectedUsageType,
        //         numberofPointsToTransfer: contractState.numberofPointsToTransfer,
        //         inputErrors: contractState.inputErrors
        //     }
        //     props.addContractWithData(contract, props.id);
        // }
        const contract: selectedContract = {
            contractId: contractState.selectedContractId,
            usageYear: contractState.selectedUsageYear,
            usageType: contractState.selectedUsageType,
            numberofPointsToTransfer: contractState.numberofPointsToTransfer,
            inputErrors: contractState.inputErrors
        }
        props.addContractWithData(contract, props.id);
    }, [contractState]);

    function removeContract() {
        const index: number = props.id;
        props.removeContracts(index);
    }

    function handleInputChange(fieldName: string, value: string) {
        if (fieldName === 'pointsToTransfer') {
            if (validatePoints(value)) {
                /**
                 * look at points and make a decision
                 */

                const pointsToTransfer: number = Number(value);
                const twentyThousandError: string = localize("static.content.transfer-points-error-max-of-20k-contract-section");
                const pointLimitError:string = localize("static.content.transfer-points-error-exceeded-available-points-overall");
                const pointError:string = localize("static.content.transfer-points-error-increments-restriction");
                if(pointsToTransfer > 20000) {
                    setContractState({
                        ...contractState,
                        inputErrors: {
                            ...contractState.inputErrors,
                            [PageErrorType.twentyThousandError]: {...InitState.inputErrors[PageErrorType.twentyThousandError], isErrored: true, message: twentyThousandError},
                        }
                    });
                } else if(isEnteredPointsGreaterThanRemaining(value)) {
                    console.log("point limit error isEnteredPointsGreaterThanRemaining");
                    setContractState({
                        ...contractState,
                        inputErrors: {
                            ...contractState.inputErrors,
                            [PageErrorType.pointLimitError]: {...InitState.inputErrors[PageErrorType.pointLimitError], isErrored: true, message: pointLimitError},
                        }
                    })
                }
                else {
                    setContractState({
                        ...contractState,
                        inputErrors: {
                            ...contractState.inputErrors,
                            [PageErrorType.pointsError]: {...InitState.inputErrors[PageErrorType.pointsError], isErrored: true, message: pointError},
                        }
                    });
                }
            } else {
                //collect errors and set at once
                let updatedInputErrors: inputErrors = JSON.parse(JSON.stringify(contractState.inputErrors));
                // let updatedPageErrors: PageErrors = JSON.parse(JSON.stringify(contractState.inputErrors));
                if(contractState.inputErrors[PageErrorType.pointsError].isErrored) {
                    updatedInputErrors = {
                        ...updatedInputErrors,
                        [PageErrorType.pointsError]: {...InitState.inputErrors[PageErrorType.pointsError], isErrored: false}
                    }
                }

                if(contractState.inputErrors[PageErrorType.twentyThousandError].isErrored) {
                    updatedInputErrors = {
                        ...updatedInputErrors,
                        [PageErrorType.twentyThousandError]: {...InitState.inputErrors[PageErrorType.twentyThousandError], isErrored: false}
                    }
                }

                if(contractState.inputErrors[PageErrorType.pointLimitError].isErrored) {
                    updatedInputErrors = {
                        ...updatedInputErrors,
                        [PageErrorType.pointLimitError]: {...InitState.inputErrors[PageErrorType.pointLimitError], isErrored: false}
                    }
                }

                if(contractState.inputErrors[PageErrorType.pointsInputError].isErrored) {
                    updatedInputErrors = {
                        ...updatedInputErrors,
                        [PageErrorType.pointsInputError]: {...InitState.inputErrors[PageErrorType.pointsInputError], isErrored: false}
                    }
                }

                setContractState({
                    ...contractState,
                    numberofPointsToTransfer: Number(value),
                    inputErrors: updatedInputErrors,
                });
                // if(contractState.pageErrors[PageErrorType.pointsError].isErrored) {
                    
                //     setContractState({
                //         ...contractState,
                //         numberofPointsToTransfer: Number(value),
                //         pageErrors: {
                //             ...contractState.pageErrors,
                //             [PageErrorType.pointsError]: {...InitState.pageErrors[PageErrorType.pointsError], isErrored: false}
                //         }
                //     });
                // } else if(contractState.inputErrors[PageErrorType.twentyThousandError].isErrored) {
                //     setContractState({
                //         ...contractState,
                //         numberofPointsToTransfer: Number(value),
                //         inputErrors: {
                //             ...contractState.inputErrors,
                //             [PageErrorType.twentyThousandError]: {...InitState.inputErrors[PageErrorType.twentyThousandError], isErrored: false}
                //         }
                //     });
                // } else {
                //     setContractState({
                //         ...contractState,
                //         numberofPointsToTransfer: Number(value)
                //     });
                // }
            }
        } else {
            setContractState({ ...contractState, [fieldName]: value });
        }
    }

    const handleSelectChange = (valueFieldName: string, data: any) => {
        switch (valueFieldName) {
            case "contractId":
                const contractsWithContractId: contract[] = props.contract.filter((val: contract) => {
                    return String(val.contractInfo) === String(data.value);
                });

                const uniqueUsageYears: string[] = Array.from(new Set(contractsWithContractId.map((val: contract) => {
                    return String(val.usageYear);
                })));

                /**
                 * check if other fields are empty or null, if not empty then we have to reset all the fields
                 */

                if(contractState.selectedUsageYear !== 0 || contractState.selectedUsageType !== "" || contractState.numberofPointsToTransfer !== 0) {
                    //the user has reset the contract id selection which has valid values
                    setContractState({
                        ...contractState,
                        selectedContractId: String(data.value),
                        selectedUsageYear: 0,
                        selectedUsageType: "",
                        numberofPointsToTransfer: 0,
                        usageYears: uniqueUsageYears,
                        usageYearDisabled: false,
                        usageTypeDisabled: true,
                        pointsDisabled: true
                    });
                } else {
                    setContractState({
                        ...contractState,
                        selectedContractId: String(data.value),
                        usageYears: uniqueUsageYears,
                        usageYearDisabled: false
                    });
                }
                break;

            case "useYear":
                const selectedYear: string = String(data.value);

                const uniqueContracts: contract[] = props.contract.filter((val: contract) => {
                    return String(val.contractInfo) === contractState.selectedContractId &&
                        String(val.usageYear) === selectedYear && val.pointsRemaining > 0 && val.isValidforTransferPoints === true;
                });

                if(uniqueContracts.length > 0) {
                    const uniqueUsageTypes: string[] = Array.from(new Set(uniqueContracts.map((val: contract) => {
                        return String(val.usageType);
                    })));

                    if(contractState.selectedUsageType !== "" || contractState.numberofPointsToTransfer !== 0) {
                        //the user is modifying a completed contract section
                        setContractState({
                            ...contractState,
                            // selectedContractId: String(data.value),
                            selectedUsageYear: Number(selectedYear),
                            usageTypes: uniqueUsageTypes,
                            selectedUsageType: "",
                            numberofPointsToTransfer: 0,
                            usageTypeDisabled: false,
                            pointsDisabled: true
                        });
                    } else {
                        setContractState({
                            ...contractState,
                            inputErrors: {
                                ...contractState.inputErrors,
                                [PageErrorType.noUsageTypePoints]: {
                                    ...contractState.inputErrors.noUsageTypePoints,
                                    isErrored: false
                                }
                            },
                            selectedUsageYear: Number(selectedYear),
                            usageTypes: uniqueUsageTypes,
                            usageTypeDisabled: false
                        });
                    }
                } else {
                    const noUsageTypePoints:string = localize("static.content.transfer-points-error-no-points-available");
                    setContractState({
                        ...contractState,
                        selectedUsageYear: Number(selectedYear),
                        selectedUsageType: "",
                        numberofPointsToTransfer: 0,
                        inputErrors: {
                            ...contractState.inputErrors,
                            [PageErrorType.noUsageTypePoints]: {
                                ...contractState.inputErrors.noUsageTypePoints,
                                isErrored: true,
                                message: noUsageTypePoints
                            }
                        }
                    });
                }
                break;

            case "useType":
                const selectedContractId: string = contractState.selectedContractId;
                const selectedUsageYear: number = contractState.selectedUsageYear;

                const contract: contract | undefined = props.contract.find((val: contract) => {
                    return String(val.contractInfo) === selectedContractId && val.usageYear === selectedUsageYear && val.usageType === data.value;
                });

                if(contractState.numberofPointsToTransfer > 0) {
                    //the user is updating a contract section which already has complete details
                    if(contract!.pointsRemaining === 0) {
                        const zeroPoints:string = localize("static.content.transfer-points-error-zero-points-entered");
                        setContractState({
                            ...contractState,
                            selectedUsageType: String(data.value),
                            numberofPointsToTransfer: 0,
                            pointsDisabled: true,
                            inputErrors: {
                                ...contractState.inputErrors,
                                [PageErrorType.zeroPoints]: {...InitState.inputErrors[PageErrorType.zeroPoints], isErrored: true, message:zeroPoints}
                            }
                        })
                    } else {
                        setContractState({
                            ...contractState,
                            selectedUsageType: String(data.value),
                            numberofPointsToTransfer: 0,
                            pointsDisabled: false
                        });
                    }
                } else {
                    if(contract!.pointsRemaining === 0) {
                        const zeroPoints:string = localize("static.content.transfer-points-error-zero-points-entered");
                        setContractState({
                            ...contractState,
                            selectedUsageType: String(data.value),
                            inputErrors: {
                                ...contractState.inputErrors,
                                [PageErrorType.zeroPoints]: {...InitState.inputErrors[PageErrorType.zeroPoints], isErrored: true, message: zeroPoints}
                            }
                        })
                    } else {
                        setContractState({
                            ...contractState,
                            selectedUsageType: String(data.value),
                            pointsDisabled: false
                        });
                    } 
                }
                break;

            default:
                break;
        }
    }

    function validatePoints(enteredNumber: string): boolean {
        const enteredPoints: number = Number(enteredNumber);
        const selectedContract: contract | undefined = props.contract.find((val: contract) => {
            return String(val.contractInfo) === contractState.selectedContractId && val.usageYear === contractState.selectedUsageYear 
                && val.usageType === contractState.selectedUsageType;
        });


        if (enteredPoints < 0 || enteredPoints % 5 !== 0 || enteredPoints > 20000 || enteredNumber === '' || enteredNumber === undefined 
                        || enteredPoints > selectedContract!.pointsRemaining ) {
            return true;
        }
        return false;
    }

    function isEnteredPointsGreaterThanRemaining(enteredNumber: string): boolean {
        const enteredPoints: number = Number(enteredNumber);
        const selectedContract: contract | undefined = props.contract.find((val: contract) => {
            return String(val.contractInfo) === contractState.selectedContractId && val.usageYear === contractState.selectedUsageYear 
                && val.usageType === contractState.selectedUsageType;
        });

        console.log("point limit error " + JSON.stringify(selectedContract));
        console.log("point limit error " + String(enteredPoints > selectedContract!.pointsRemaining));
        return enteredPoints > selectedContract!.pointsRemaining;
    }

    function isDisabled(component: string): string {
        switch (component) {
            case "usage-year":
                return contractState.selectedContractId === '' ?
                    "container-individual-component-disabled container-individual-component" : "container-individual-component";
            case "usage-type":
                return contractState.selectedUsageYear === 0 || contractState.inputErrors.noUsageTypePoints.isErrored ? 
                    "container-individual-component-disabled container-individual-component" : "container-individual-component";
            case "points":
                return contractState.selectedUsageType === '' || contractState.inputErrors[PageErrorType.zeroPoints].isErrored ?
                    "container-individual-component-disabled container-individual-component" : "container-individual-component";
            default:
                return "container-individual-component-disabled container-individual-component";
        }
    }

    function convertToItemArray(items: string[]): Item[] {
        return items.map((val: string) => {
            const item: Item = {
                value: val,
                description: val
            };
            return item;
        })
    }
    const tip: [Tip] = [{ label: ``, desc: `${localize("static.content.number-of-point-transfer")}` }];

    function getErrorStatusForUsageYearField(): string {
        if(contractState.inputErrors[PageErrorType.noUsageTypePoints].isErrored) {
            return contractState.inputErrors[PageErrorType.noUsageTypePoints].message;
        } else if(props.currentContract.inputErrors[PageErrorType.usageYearInputError].isErrored) {
            return props.currentContract.inputErrors[PageErrorType.usageYearInputError].message;
        }

        return "";
    }

    function getErrorStatus(): string {
        if(contractState.inputErrors[PageErrorType.pointsInputError].isErrored) {
            return props.currentContract.inputErrors[PageErrorType.pointsInputError].message;
        } else if(contractState.inputErrors[PageErrorType.zeroPoints].isErrored) {
            return contractState.inputErrors[PageErrorType.zeroPoints].message;
        } else if(contractState.inputErrors[PageErrorType.pointsError].isErrored) {
            return contractState.inputErrors[PageErrorType.pointsError].message;
        } else if(contractState.inputErrors[PageErrorType.twentyThousandError].isErrored) {
            return contractState.inputErrors[PageErrorType.twentyThousandError].message;
        } else if(contractState.inputErrors[PageErrorType.pointLimitError].isErrored) {
            return contractState.inputErrors[PageErrorType.pointLimitError].message;
        }

        return "";
    }

    function getErrorStatusForContractIdInput(): string {
        if(contractState.inputErrors[PageErrorType.contractIdInputError].isErrored) {
            return contractState.inputErrors[PageErrorType.contractIdInputError].message;
        }

        return "";
    }

    return (
        <div className="contracts-info-root">
            <div className="container-individual-component">
                <span>Contract ID</span>
                <MvSelect
                    name="contract-id"
                    label={contractState.selectedContractId}
                    onChange={(e:any) => handleSelectChange('contractId', e.target)}
                    items={convertToItemArray(props.uniqueContracts)}
                    value={contractState.selectedContractId}
                    hasError={contractState.inputErrors.contractIdInputError.isErrored}
                    errorMessage={getErrorStatusForContractIdInput()}
                />
            </div>
            <div className={isDisabled("usage-year")}>
                <span>Use Year</span>
                <MvSelect
                    name="use year"
                    label={String(contractState.selectedUsageYear === 0 ? "" : contractState.selectedUsageYear)}
                    onChange={(e: any) => handleSelectChange('useYear', e.target)}
                    items={convertToItemArray(contractState.usageYears)}
                    value={String(contractState.selectedUsageYear)}
                    hasError={contractState.inputErrors[PageErrorType.usageYearInputError].isErrored || contractState.inputErrors.noUsageTypePoints.isErrored}
                    errorMessage={getErrorStatusForUsageYearField()}
                />
            </div>
            <div className={isDisabled("usage-type")}>
                <span>{localize("static.content.types-of-points-to-transfer-label")}</span>
                <MvSelect
                    name="Type"
                    label={contractState.selectedUsageType}
                    onChange={(e: any) => handleSelectChange('useType', e.target)}
                    items={convertToItemArray(contractState.usageTypes)}
                    value={contractState.selectedUsageType}
                    hasError={contractState.inputErrors.usageTypeInputError.isErrored}
                    errorMessage={contractState.inputErrors.usageTypeInputError.message}
                />
            </div>
            <div className={isDisabled("points")}>
                <span>{localize("static.content.number-of-points-to-transfer-label")} &nbsp;
                    <div className="number-of-point-transfer-tooltip">
                        <ToolTip useRefToPosition={false} id={`contract-generic-${contractState.selectedContractId}`} tabIndex={-1} tip={tip} position={Position.CENTER}>
                            <span className="info-icon">{"i"}</span>
                        </ToolTip>
                    </div>
                </span>
                <MvTextOrEdit
                    onChange={(val) => handleInputChange('pointsToTransfer', val)}
                    onBlur={(e) => { }}
                    value={String(contractState.numberofPointsToTransfer)}
                    placeholder={""}
                    isEditing={true}
                    hideLabel={true}
                    label={""}
                    id={'number-of-points-to-transfer'}
                    name={'number-of-points-to-transfer'}
                    hasError={contractState.inputErrors[PageErrorType.pointsInputError].isErrored || contractState.inputErrors[PageErrorType.pointsError].isErrored || contractState.inputErrors[PageErrorType.zeroPoints].isErrored 
                                || contractState.inputErrors[PageErrorType.twentyThousandError].isErrored || contractState.inputErrors[PageErrorType.pointLimitError].isErrored}
                    errorMessage={getErrorStatus()}
                    isRequired={true}
                    inputComponent='text'
                />
                <span className="fw-normal">Increment of 5 points</span>
            </div>
            {/* TODO: Make this into a grid layout in the future and remove the hardcoded margin-left for this property */}
            {
                props.displayRemoveButton &&
                    <div className="container-remove-contract">
                        <div className="inner-container-remove-contract"  onClick={removeContract}>
                            <a>Remove Contract</a>
                            <FontAwesomeIcon icon={faTrash} />
                        </div>
                    </div>
            }
        </div>
    );
}

export default ContractsInfo;